import { Link, useLocation } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";
import { Calendar } from "lucide-react";

export default function FloatingCTA() {
    const t = useT();
    const { pathname } = useLocation();

    // Hide on the contact page itself.
    if (pathname === "/contact") return null;

    return (
        <Link
            to="/contact"
            data-testid="floating-cta"
            aria-label={t.nav.ctaShort}
            className="floating-cta-anchor"
            style={{
                position: "fixed",
                background: "var(--orange)",
                color: "#fff",
                fontFamily: "'Source Serif Pro', Georgia, serif",
                fontWeight: 600,
                letterSpacing: "0.01em",
                border: "1px solid var(--orange)",
                boxShadow: "0 10px 28px rgba(255,152,0,0.35)",
                cursor: "pointer",
                zIndex: 55,
                transition: "transform 200ms ease, box-shadow 200ms ease, background-color 200ms ease",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 14px 32px rgba(255,152,0,0.45)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 10px 28px rgba(255,152,0,0.35)"; }}
        >
            <span className="floating-cta-icon" aria-hidden="true">
                <Calendar size={18} strokeWidth={2} />
            </span>
            <span className="floating-cta-label">{t.nav.ctaShort}</span>
        </Link>
    );
}
